/**
 * "Cam" button (web only) for logged-in users. Rendered in-flow at the top of
 * the right nav (DesktopRightNav). Opens the caller's own mutual room
 * (`m-<base32(myDid)>`): any of their mutuals (both follow each other) can join;
 * the worker enforces that. Hidden for guests -- mutual cam is a logged-in
 * feature (guests have no social graph). Native has a `.tsx` stub.
 */

import {Pressable} from 'react-native'
import {useLingui} from '@lingui/react/macro'

import {useSession} from '#/state/session'
import {atoms as a, useTheme} from '#/alf'
import {VideoClip_Stroke2_Corner0_Rounded as VideoIcon} from '#/components/icons/VideoClip'
import {Text} from '#/components/Typography'
import {navigate} from '#/Navigation'
import {myMutualRoomSlug} from './cfcalls/mutualRoom'

export function HomeCamButton() {
  const t = useTheme()
  const {t: l} = useLingui()
  const {hasSession, currentAccount} = useSession()

  if (!hasSession || !currentAccount?.did) {
    return null
  }

  const onPress = () => {
    void navigate('Call', {roomId: myMutualRoomSlug(currentAccount.did)})
  }

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={l`Start a cam with your mutuals`}
      accessibilityHint={l`Opens your video room; any of your mutuals can join`}
      onPress={onPress}
      style={[
        a.flex_row,
        a.align_center,
        a.justify_center,
        a.gap_sm,
        a.rounded_full,
        a.px_lg,
        a.py_md,
        {backgroundColor: t.palette.primary_500},
      ]}>
      <VideoIcon size="md" fill={t.palette.white} />
      <Text style={[a.font_bold, {color: t.palette.white}]}>Cam</Text>
    </Pressable>
  )
}
